var exports = {
  "k": "x93eb46d8--86341c--container",
  "X": "x93eb46d8--86341c--action",
};

module.exports = exports;
